import { TrackingProp } from 'react-tracking';
import { useEffect } from 'react';
import { ProductListViewedEvent } from '../analyticsWrapper';
import { Product } from 'types/Product';
import { ProductListViewedProperties } from 'itly';

export function useTrackProductListViewed(
  tracking: TrackingProp<ProductListViewedEvent>,
  breadcrumbs: { name: string }[],
  products: Product[],
  ...dependencies: any[]
): void {
  useEffect(() => {
    // From ProductListViewedProperties:
    // Category: Product category being viewed. Use / as a delimiter to specify
    // Up-to 5 levels of hierarchy (e.g. Apparel/Men/T-Shirts).
    const categoryNames = breadcrumbs.map(({ name }) => name).join('/');
    const data: ProductListViewedProperties = {
      category: categoryNames,
      products: products.map(productToAnalyticsData)
    };
    tracking.trackEvent({ type: 'productListViewed', data });
  // TODO: Refactor this dependency
  // eslint-disable-next-line react-hooks/exhaustive-deps    
  }, dependencies);
}

function productToAnalyticsData(product: Product, position = 0) {
  return {
    product_id: product.productId || parseInt(product.id),
    price: product.lowestPrice || product.price || undefined,
    // Position (position in the product list - ex. 3)
    position: position + 1
  };
}
